import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAt } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'

const SectionContact = () => {
    return (
        <div className="row text-white text-center pb-3">
            <h1 className="section-header">Contact</h1>
            <p className="mb-1">Have the urge to get in touch?</p>
            <p>Feel free to send me an e-mail or use either one of my social media tags below to reach me!</p>

            <div className="d-flex justify-content-center">
                <div className="px-2">
                    <a href="mailto:sorenbn@outlook.com" target="_blank">
                        <FontAwesomeIcon icon={faAt} size={'3x'} color={'white'} />
                    </a>
                </div>
                <div className="px-2">
                    <a href="https://www.linkedin.com/in/s%C3%B8ren-bach-nielsen-63bb35a9/" target="_blank">
                        <FontAwesomeIcon icon={faLinkedin} size={'3x'} color={'white'} />
                    </a>
                </div>
            </div>

        </div>
    )
}

export default SectionContact
